import { Configuration } from "@azure/msal-browser";

const redirectUri = process.env.REACT_APP_REDIRECT_URI;
const clientID = process.env.REACT_APP_CLIENT_ID;
const authority = process.env.REACT_APP_AUTHORITY;

export const msalConfig: Configuration = {

    auth: {
        clientId: `${clientID}`,
        authority: `${authority}`,
        redirectUri: `${redirectUri}`,// Update this to your app's redirect URI
        navigateToLoginRequestUrl: true, // Navigate to original request after login
    },
    cache: {
        cacheLocation: "localStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" for IE11/Edge compatibility
    },
    system: {
        allowRedirectInIframe: false, // Important for security
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                console.log(message);
            },
        }
    }
};

export const loginRequest = {
    scopes: ["User.Read", "User.Read.All"]
}
